import * as React from 'react';
const IntolleranzaAlLattosioIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="m75.9 124.1-14.31 14.31M138.41 61.59l-18.37 18.37"
      className="prefix__cls-1"
    />
    <path
      d="M75.9 131.71V86.05l11.42-15.22 11.41 15.22v48.19z"
      className="prefix__cls-2"
    />
    <path
      d="M115.22 86.05H98.73L87.32 70.83h26.63l10.15 15.22v45.66l-25.37 2.53"
      className="prefix__cls-2"
    />
    <path
      d="M87.32 65.76h26.63v5.07H87.32zM75.9 86.05h15.22"
      className="prefix__cls-2"
    />
    <path
      d="M117.76 110.15c0 3.5-2.56 6.34-5.71 6.34s-5.71-2.84-5.71-6.34 5.71-11.41 5.71-11.41 5.71 7.91 5.71 11.41"
      className="prefix__cls-1"
    />
  </svg>
);
export default IntolleranzaAlLattosioIcon;
